
import React from 'react';
import { getDayAngle } from '../utils/cycleUtils';

interface CurrentDayIndicatorProps {
  center: { x: number; y: number };
  cycleLength: number;
  lastPeriodDate: Date;
}

export const CurrentDayIndicator = ({ center, cycleLength, lastPeriodDate }: CurrentDayIndicatorProps) => {
  const calculateCurrentDay = () => {
    const today = new Date();
    const timeDiff = today.getTime() - lastPeriodDate.getTime();
    const daysSinceLastPeriod = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    
    // Assurer que le résultat est toujours positif et dans la plage du cycle
    let currentDay = ((daysSinceLastPeriod % cycleLength) + cycleLength) % cycleLength + 1;
    
    // S'assurer que le jour est dans la plage valide
    currentDay = Math.max(1, Math.min(currentDay, cycleLength));
    
    console.log('Current day calculation:', {
      today: today.toISOString(),
      lastPeriodDate: lastPeriodDate.toISOString(),
      daysSinceLastPeriod,
      cycleLength,
      currentDay,
      timeDiff
    });
    
    return currentDay;
  };

  const currentDay = calculateCurrentDay();
  const angle = getDayAngle(currentDay);
  const radius = 190;

  const x = center.x + radius * Math.cos((angle - 90) * (Math.PI / 180));
  const y = center.y + radius * Math.sin((angle - 90) * (Math.PI / 180));

  return (
    <g>
      <circle
        cx={x}
        cy={y}
        r={8}
        fill="red"
        stroke="white"
        strokeWidth={2}
        className="animate-pulse"
      />
      <text
        x={x}
        y={y - 15}
        textAnchor="middle"
        fill="black"
        fontSize="12"
        fontWeight="bold"
      >
        Jour {currentDay}
      </text>
    </g>
  );
};
